$(document).on("turbolinks:load", () => {
    // メニューバー処理
    $('#mb_menu div').click(function(){
        if( $(this).hasClass('active') ){
            $(this).removeClass('active');
            $('#header-nav').removeClass('is-show');
        } else {
            $(this).addClass('active');
            $('#header-nav').addClass('is-show');
        }
    });

    // 画面の解像度取得処理
    get_screen_size_for_user();
    get_screen_size_for_admin();
    
})

function get_screen_size_for_user() {
    var s = window.parent.screen.width + " × " + window.parent.screen.height + "px";
    var html = `<input id="login_form_scr_size" type="hidden" name="user_login_form[scr_size]" value="${s}" >`
    $("#login-user--scr_size").append(html);

}
function get_screen_size_for_admin() {
    var s = window.parent.screen.width + " × " + window.parent.screen.height + "px";
    var html = `<input id="login_form_scr_size" type="hidden" name="admin_login_form[scr_size]" value="${s}" >`
    $("#login-admin--scr_size").append(html);

}